<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import { useTaskGeneralInfoCreate } from '../../model/task-general-info-create.hook'
import TaskInfoList from './TaskInfoList.vue'
import TaskInfoItem from './TaskInfoItem.vue'
import TaskCreationPickerDeadline from './TaskCreationPickerDeadline.vue'

defineOptions({
  name: 'TaskGeneralInfoCreate',
})

const {
  refTaskType,
  refTaskTypeOptions,
  refTaskTypeState,
  refStage,
  refStageOptions,
  refStageState,
  refPriority,
  refPriorityOptions,
} = useTaskGeneralInfoCreate()
</script>

<template>
  <TaskInfoList>
    <TaskInfoItem title="Task type">
      <AppSelect
        v-model="refTaskType"
        :options="refTaskTypeOptions"
        :state="refTaskTypeState"
        placeholder="Select here"
        clearable
      />
    </TaskInfoItem>
    <TaskInfoItem title="Stage">
      <AppSelect
        v-model="refStage"
        :options="refStageOptions"
        :state="refStageState"
        placeholder="Select here"
        clearable
      />
    </TaskInfoItem>
    <TaskInfoItem title="Priority">
      <AppSelect
        v-model="refPriority"
        :options="refPriorityOptions"
        placeholder="Select here"
      />
    </TaskInfoItem>
    <TaskInfoItem title="Deadline">
      <TaskCreationPickerDeadline />
    </TaskInfoItem>
  </TaskInfoList>
</template>